import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "sk_token";

export const api = axios.create({ baseURL: API_BASE, timeout: 180000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const p = window.location.pathname;
    if (err?.response?.status === 401 && !p.startsWith("/q/") && !p.startsWith("/avklaring/") && !p.startsWith("/foresporsel") && p !== "/login") {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  if (d && typeof d === "object" && typeof d.message === "string") return d.message;
  return e?.message || "Noe gikk galt";
}
